<div class="max-w-8xl mx-auto p-6">
    <!-- Container for form and chart -->
    <div class="flex flex-col md:flex-row">
      
      <!-- Form on the left -->
      <div class="w-full md:w-1/3 bg-white p-6 rounded-lg shadow-md">
        <h2 class="text-2xl font-semibold text-gray-800 mb-6">Submit Monthly Sales Data</h2>
        <form [formGroup]="salesForm" (ngSubmit)="submitSalesData()" class="space-y-6">
          
          <!-- Month Input -->
          <div>
            <label for="month" class="block text-sm font-medium text-gray-700">Month</label>
            <select id="month" formControlName="month"
              class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <option value="">Select Month</option>
              <!-- <option *ngFor="let month of monthNames" [value]="month">{{ month }}</option> -->
              <option *ngFor="let month of monthNames" [value]="month.value + '-' + currentYear">
                {{ month.display }}
              </option>
            </select>
            <div *ngIf="salesForm.get('month')?.invalid && salesForm.get('month')?.touched" class="text-red-500 text-xs mt-0.5">
              Month is required.
            </div>
          </div>
  
          <!-- Total Sales Input -->
          <div>
            <label for="totalSales" class="block text-sm font-medium text-gray-700">Total Sales</label>
            <input type="number" id="totalSales" formControlName="totalSales"
              class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" placeholder="Enter total sales" required>
            <div *ngIf="salesForm.get('totalSales')?.invalid && salesForm.get('totalSales')?.touched" class="text-red-500 text-xs mt-0.5">
              Total sales is required.
            </div>
          </div>
  
          <!-- Gross Profit Input -->
          <div>
            <label for="grossProfit" class="block text-sm font-medium text-gray-700">Gross Profit</label>
            <input type="number" id="grossProfit" formControlName="grossProfit"
              class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" placeholder="Enter gross profit" required>
            <div *ngIf="salesForm.get('grossProfit')?.invalid && salesForm.get('grossProfit')?.touched" class="text-red-500 text-xs mt-0.5">
              Gross profit is required.
            </div>
          </div>

           <!-- DNC Input -->
           <div>
            <label for="DNC" class="block text-sm font-medium text-gray-700">Delivered Not Closed (DNC)</label>
            <input type="number" id="DNC" formControlName="DNC"
              class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" placeholder="Enter DNC number" required>
            <div *ngIf="salesForm.get('DNC')?.invalid && salesForm.get('DNC')?.touched" class="text-red-500 text-xs mt-0.5">
              DNC number is required.
            </div>
          </div>
  
          <!-- Inventory Done -->
          <div>
            <label for="inventory" class="block text-sm font-medium text-gray-700">Inventory Done (I.D.)</label>
            <select id="inventory" formControlName="inventory"
              class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required>
              <option [selected]="true" value="">Select Inventory Status</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div *ngIf="salesForm.get('inventory')?.invalid && salesForm.get('inventory')?.touched" class="text-red-500 text-xs mt-0.5">
              Inventory status is required.
            </div>
          </div>
  
         
  
          <!-- Submit Button -->
          <div>
            <button type="submit" [disabled]="salesForm.invalid"
              class="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-500 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              Submit Sales Data
            </button>
          </div>
  
        </form>
      </div>
  
      <!-- Chart on the right -->
      <div class="hidden md:flex w-full md:w-2/3 mt-6 md:mt-0 md:ml-4 bg-white p-6 rounded-lg shadow-md justify-center">
        <canvas id="salesChart"></canvas>
      </div>
      
  
    </div>
  
    <!-- Data Grid for Submitted Sales Data -->
    <div class="mt-10 block md:hidden"> <!-- Visible only on mobile -->
      <h3 class="text-2xl font-semibold text-gray-800 mb-6">Submitted Sales Data</h3>
      <div class="overflow-x-auto">
        <table class="min-w-full bg-white shadow-lg rounded-lg">
          <thead class="bg-indigo-600 text-white">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Month</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Total Sales</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Gross Profit</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">DNC</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Inventory Done</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr *ngFor="let sales of submittedSales.reverse()" class="hover:bg-gray-50 transition-colors">
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ sales.month }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ sales.totalSales | currency }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ sales.grossProfit | currency }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ sales.DNC | currency }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium {{ sales.inventory === true ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800' }}">
                  {{ sales.inventory === true ? 'Yes' : 'No' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
      
    <div class="mt-10 hidden md:block">
      <div class="bg-white shadow-lg rounded-lg p-6 max-w-6xl mx-auto">
        <!-- Card container -->
        <h3 class="text-2xl font-semibold text-gray-800 mb-6">Submitted Sales Data</h3>
        <div class="overflow-x-auto">
          <form [formGroup]="salesGridForm">
            <table class="min-w-full items-center bg-white shadow-lg rounded-lg">
              <thead class="bg-indigo-600 text-white">
                <tr>
                  <th class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Month</th>
                  <th class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Total Sales</th>
                  <th class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Gross Profit</th>
                  <th class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">DNC</th>
                  <th class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Inventory Done</th>
                  <th class="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200" *ngIf="salesArray?.controls?.length && salesArray.controls.length > 0">
                <ng-container formArrayName="salesArray">
                  <ng-container *ngFor="let control of salesArray.controls; let i = index" [formGroupName]="i">
                    <tr class="hover:bg-gray-50 transition-colors">
                      <td class="px-6 py-4">
                        <select formControlName="month" class="border border-gray-300 rounded-md shadow-sm text-sm">
                          <option *ngFor="let month of monthNames" [value]="month.value + '-' + currentYear">{{ month.display }}</option>
                        </select>
                      </td>
                      <td class="px-6 py-4">
                        <input type="number" formControlName="totalSales" class="w-24 border border-gray-300 rounded-md shadow-sm text-sm">
                      </td>
                      <td class="px-6 py-4">
                        <input type="number" formControlName="grossProfit" class="w-24 border border-gray-300 rounded-md shadow-sm text-sm">
                      </td>
                      <td class="px-6 py-4">
                        <input type="number" formControlName="DNC" class="w-24 border border-gray-300 rounded-md shadow-sm text-sm">
                      </td>
                      <td class="px-6 py-4">
                        <select formControlName="inventory" class="border border-gray-300 rounded-md shadow-sm text-sm">
                          <option [value]="true">Yes</option>
                          <option [value]="false">No</option>
                        </select>
                      </td>
                      <td class="px-6 py-4">
                        <button disabled (click)="saveGridSalesData(i)" class="text-green-600 hover:text-green-900">Save</button>
                        <button disabled (click)="deleteGridSalesData(i)" class="text-red-600 hover:text-red-900 ml-4">Delete</button>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>
    
    
      
      
      
      
  </div>
  